import ivyStore from '@ivy/fts/ivyStore'
import showBindPhone from '@ivy/fts/showBindPhone'
import router from '../router'
export class Store {
  logined = ivyStore.logined
  bindPhoneConfig = {
    color: '#ffb450',
    tip: '手机号和微信号都可以作为上课的账号',
  }
  async login(force = 0, disableOther = true) {
    if (router.currentRoute.query.pageFor === 'adminCheck') return 'adminCheck'
    return await ivyStore.login2(force, disableOther)
  }
  async bindPhone(options) {
    return await ivyStore.bindPhone(options)
  }
  async showBindPhone(redirectUrl?) {
    return await showBindPhone(redirectUrl)
  }
}

export default new Store()
